import React, { useEffect } from 'react';
import styled from 'styled-components';
import SettingWidgetIcon from '../../Common/SvgIcon/SettingWidgetIcon';
import Tabs from './Tabs';
import { useSelector } from 'react-redux';

const Sidebar = styled.div`
  border-right: 1px solid rgba(162, 162, 162, 0.35);
  overflow-y: auto;

    position: sticky;
    top: 0px;
    height: calc(100vh - 70px);
  /* Hide scrollbar - Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0,0,0,0.3) transparent;
  z-index: ${(p) => p?.popUpActive ? '1' : p?.zindexActive == true ? '1' : '1000000'};
  /* Chrome, Edge, Safari */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5);
  }
`;

const SettingHeader = styled.div`
  width: 79%;
  display: flex;
  justify-content: space-between;
  margin: 20px auto;
  // padding-bottom: 18px;
  font-weight: 600;
  font-size: 20px;
  position: relative;
    font-family:inherit;

    align-items: center;
  &::after {
    position: absolute;
    content: '';
    top: 90%;
    left: 50%;
    transform: translate(-50%);
    width: 105%;
    height: 1px;
    border-radius: 10px;
    background-color: rgba(99, 99, 99, 0.2);
    display:none;
  }
    & > div{
    text-align: justify;
    color:${(props) => props?.colorChange ? props?.colorChange : ''};
    font-family: inherit;
    }
`;

const NewSideBar = ({
  headerName,
  tabs,
  initialActiveTab = 1,
  buttonTitle,
  showDropDown,
  setShowDropDown,
}) => {
  const { zindexActive} = useSelector((state) => state.topicBuilder) || {};
  const popUpActive = useSelector((state) => state.topicBuilder.popUpActive);
  // console.log(initialActiveTab,tabs,"initialActiveTab");

  const { personalDetailsData } = useSelector((state) => state.tenantSetting);
  
  return (
    <Sidebar popUpActive={popUpActive} 
                              zindexActive={zindexActive}>
      <SettingHeader style={{marginBottom:'0px'}}  colorChange={(personalDetailsData?.is_custom == 'custom' && personalDetailsData?.heading_accent) ? personalDetailsData?.heading_accent : '' }>
        <div>{headerName}</div>
        {/* {SettingWidgetIcon} */}
      </SettingHeader>
      {tabs.map((data) => (
        <Tabs
          value={data}
          active={initialActiveTab}
          key={data.id}
          name={headerName}
          buttonTitle={buttonTitle}
          showDropDown={showDropDown}
          setShowDropDown={setShowDropDown}
        />
      ))}
    </Sidebar>
  );
};

export default NewSideBar;
